<template>
    <label class="_e-FormLabel">
        <span class="_e-FormLabel__prefix">{{item.id}} <i class="la la-arrow-right"></i> </span>
        <span class="_e-FormLabel__group">
            <span v-html="item.title + ' *'"></span>
            <span class="_e-FormLabel__sous-title" v-html="item.sousTitle" v-if="item.sousTitle"></span>
        </span>
    </label>
</template>
<script>
  export default {
    name: 'FormLabel',
    props: {
      item: {type: [Array, Object], default: () => {}},
    },
  };
</script>
<style scoped>
    ._e-FormLabel {
        display: inline-flex;
        font-size: 1.6rem;
        font-weight: normal;
        line-height: 1.9rem;
        margin-bottom: 40px;
        text-align: left;
        width: 100%;
    }

    ._e-FormLabel__group {
        display: inline-flex;
        flex-direction: column;
        margin-left: 5px;
    }

    ._e-FormLabel__sous-title {
        font-size: 1.3rem;
        line-height: 1.6rem;
        font-weight: lighter;
        opacity: 0.5;
    }

    ._e-FormLabel__prefix {
        display: inline-block;
        font-size: 1.3rem;
        line-height: 1.6rem;
        padding-bottom: 4px;
        white-space: nowrap;
        vertical-align: middle;
        flex: 0 0 auto;
        width: 3rem;
    }

</style>